import { styled } from 'styled-components';

export const P = styled.p``;

export const Bold = styled.strong`
  font-weight: 700;
`;

export const Italic = styled.em``;

export const Underline = styled.u``;

export const OrderedList = styled.ol`
  counter-reset: counter;
  display: revert;
  max-width: 100%;

  li {
    display: flex;
    width: 100%;
    max-width: 100%;
    counter-increment: counter;
    gap: 0.72em;

    &::before {
      display: inline-block;
      content: counter(counter) '. ';
      font-weight: 600;
      opacity: 0.5;
      width: 0.4em;
      white-space: nowrap;
    }

    > span {
      display: inline-block;
    }
  }
`;

export const UnorderedList = styled.ul`
  display: revert;
  max-width: 100%;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    gap: 0.72em;

    &::before {
      display: inline-block;
      font-weight: 600;
      width: 0.4em;
      height: 0.4em;
      background: currentColor;
      opacity: 0.5;
      border-radius: 0.1em;
      content: '';
      position: relative;
      left: 0.16em;
    }

    > span {
      display: inline-block;
    }
  }
`;

export const Heading = styled.h5`
  font-size: 1.5em;
  font-weight: 700;
`;

export const Link = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary[700]};
  }
`;
